import axios from 'axios'
import commonMethods from '@/commonMethods'
const { registerError } = commonMethods()

// initial state
const state = {
  experienceTypes: [],
  experienceType: null,
  experiences: [],
  experience: null,
  slot: null,
  turn: null,
  appointment: null
}

// getters
const getters = {
  getExperienceTypes(state) {
    return state.experienceTypes
  },
  getExperienceType(state) {
    return state.experienceType
  },
  getExperiences(state) {
    return state.experiences
  },
  getExperience(state) {
    return state.experience
  },
  getSlot(state) {
    return state.slot
  },
  getTurn(state) {
    return state.turn
  },
  getAppointment(state) {
    return state.appointment
  }
}

// actions
const actions = {
  async getExperienceTypes({ commit, rootState, state }) {
    if (!state.experienceTypes || state.experienceTypes.length == 0) {
      try {
        let url = process.env.VUE_APP_PATH + 'experience/types'
        const response = await axios.get(url)
        const experienceTypesWithImageDataUrls = response.data.map(
          (experienceType) => {
            return {
              ...experienceType,
              imageConverted: `data:image/png;base64,${experienceType.image}`
            }
          }
        )
        commit('setExperienceTypes', experienceTypesWithImageDataUrls)
        return response
      } catch (err) {
        registerError(err, 'getExperienceTypes')
        return err
      }
    }
  },
  async getExperiencesByType({ commit }, experienceTypeId) {
    let url = `${process.env.VUE_APP_PATH}experience/types/${experienceTypeId}`
    const response = await axios.get(url)
    const experiencesWithImageDataUrls = response.data.map((experience) => {
      return {
        ...experience,
        imageConverted: `data:image/png;base64,${experience.image}`
      }
    })
    commit('setExperiences', experiencesWithImageDataUrls)
    return experiencesWithImageDataUrls
  },
  async getExperiencesByTypeCode({ commit }, experienceTypeCode) {
    let url = `${process.env.VUE_APP_PATH}experience/types/code/${experienceTypeCode}`
    const response = await axios.get(url)
    const experiencesWithImageDataUrls = response.data.map((experience) => {
      return {
        ...experience,
        imageConverted: `data:image/png;base64,${experience.image}`
      }
    })
    commit('setExperiences', experiencesWithImageDataUrls)
    return experiencesWithImageDataUrls
  },
  async getExperience({ commit }, experienceId) {
    let url = `${process.env.VUE_APP_PATH}experience/${experienceId}`
    let experience = (await axios.get(url)).data
    experience.imageConverted = `data:image/png;base64,${experience.image}`
    commit('setExperience', experience)
    return experience
  },
  async getExperienceByCode({ commit }, experienceCode) {
    //try{
      let url = `${process.env.VUE_APP_PATH}experience/code/${experienceCode}`
      let experience = (await axios.get(url)).data
      experience.imageConverted = `data:image/png;base64,${experience.image}`
      commit('setExperience', experience)
      return experience
    //} catch (err) {
    //  registerError(err, 'getExperienceByCode')
    //  return err
    //}
  },
  async createExperienceTurn({ commit }, experienceTurnData) {
    let url = `${process.env.VUE_APP_PATH}saveExperienceTurn`
    let turn = (await axios.post(url, experienceTurnData)).data
    commit('setTurn', turn)
    return true
  },
  updateTurnSession({ commit }, data) {
    let url = `${process.env.VUE_APP_PATH}updateTurnSession`
    axios.post(url, data)
  },
  updateTurn({ commit }, turn) {
    commit('setTurn', turn)
  },
  updateSlot({ commit }, slot) {
    commit('setSlot', slot)
  }
}

// mutations
const mutations = {
  setExperienceTypes(state, value) {
    state.experienceTypes = value
  },
  setExperiences(state, value) {
    state.experiences = value
  },
  setExperience(state, value) {
    state.experience = value
  },
  setSlot(state, value) {
    state.slot = value
  },
  setTurn(state, value) {
    state.turn = value
  },
  setExperienceType(state, value) {
    state.experienceType = value
  },
  setAppointment(state, value) {
    state.appointment = value
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
